import { CalendarTimeAddFillIcon, CloseCircleFillIcon, Document3FillIcon, Tag, TimeFilledIcon } from 'ui';
import type { ChangeRequestStatus } from 'models/service';

type P = {
  startTime: Date;
  status?: ChangeRequestStatus;
};

const EventChangeRequestStatusTag = ({ status }: P) => {
  if (status === 'pending') {
    return (
      <Tag color="warning" icon={<TimeFilledIcon />}>
        Pending
      </Tag>
    );
  }

  if (status === 'denied') {
    return (
      <Tag color="error" icon={<CloseCircleFillIcon />}>
        Declined by admin
      </Tag>
    );
  }

  if (status === 'expired') {
    return <Tag icon={<CalendarTimeAddFillIcon />}>Past due</Tag>;
  }

  return <Tag icon={<Document3FillIcon />}>Not published</Tag>;
};

export default EventChangeRequestStatusTag;
